import Vue from 'vue';
import FadeTransition from '~/components/common/Transitions/FadeTransition.vue';
import SlideUpTransition from '~/components/common/Transitions/SlideUpTransition.vue';

Vue.component('Fade', FadeTransition);
Vue.component('Slideup', SlideUpTransition);
